import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: {
    page: 1,
    totalPage: 2
  },
  condition: {
    userNo: 0,
    page: 1,
    limit: 10,
    storeNo: null,
    requestStatus:null,
    isCancelled: null,
    searchText: '',
    regDate: '',
    startDate: '',
    endDate: ''
  },
  detail: {
    bizTransactionNo:'',
    storeNo:'',
    amount:0,
    action:'',
    actDate:'',
    bizRequestNo:' - ',
    reviewNo:'',
    orderNo:'',
    orderManageNo:' - ',
    memo:'',
    storeName:'',
    totalBizMoneyBeforeThis:'',

    depositor:null,
    requestAmount:null,
    acceptAmount:null,
    status:null,
    requestDate:null,
    checkedDate:null,
    completedDate:null,
    cancelledDate:null,
    cancelledReason:null,
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
